'use client';

import { c as _c } from "react/compiler-runtime";
import { AuthProvider } from './auth-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from '@/components/providers/posthog-provider';
import { SidebarProvider } from '@/components/ui/sidebar';
const queryClient = new QueryClient();
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <AuthProvider><QueryClientProvider client={queryClient}><PostHogProvider><SidebarProvider>{children}</SidebarProvider></PostHogProvider></QueryClientProvider></AuthProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}